<template>
  <div class="room-status-future">
    <div style="display: flex; align-items: center;">
      <div class="yellow-button-like">远期房态</div>
      <el-popover placement="bottom" width="300px">
        <template #reference>
          <div style="width: 80px;">
            <img src="@/assets/img/question.png" alt="" style="width: 16px; height: 16px; margin-right: 8px;">
            <span>图例说明</span>
          </div>
        </template>
        <div class="top-bar">
          <div class="room-status-list">
            <div class="status-item" v-for="item in statusList" :key="item.id">
              <div :class="`dot bg-${item.name}`"></div>
              <span>{{ item.label }}</span>
            </div>
          </div>
          <div class="room-status-list">
            <div class="status-item" v-for="item in cleanStatusList" :key="item.id">
              <img :src="item.imgUrl" alt="">
              <span>{{ item.label }}</span>
            </div>
          </div>
        </div>
      </el-popover>
      <div @click="handleFilterRoomType" style="margin-left: 16px; color: blue; cursor: pointer;">筛选</div>
    </div>
    <div class="status-container" v-loading="isReqStatus">
      <div class="rs-table">
        <div class="rs-thead">
          <div class="rs-tr">
            <div class="rs-th" style="z-index: 0;"></div>
            <div class="rs-th no-l-border" style="z-index: 0;">
              <div class="date-selector m-l-l-110">
                <el-icon class="hover cursor-p" size="20" @click="handleChangeDate('forward')"><arrow-left-bold /></el-icon>
                <el-date-picker
                  popper-class="z-i-10000"
                  v-model="selDate"
                  type="date"
                  format="YYYY-MM-DD"
                  value-format="YYYY-MM-DD"
                  :clearable="false"
                  @change="handleChangeDate" />
                <el-icon class="hover cursor-p" size="20" @click="handleChangeDate('backward')"><arrow-right-bold /></el-icon>
              </div>
              <!-- <div class="room-selector m-l-l-110">
                今日房源
              </div> -->
            </div>
            <div class="rs-th" v-for="date in dateList" :key="date.date">
              <div :class="`head-date-item ${date.dateVal === todayValue ? 'head-today' : ''}`">
                <span class="font-16">{{ date.date }}{{ date.week }}</span>
                <span class="font-12 color-d-text font-w-n">剩余{{ date.roomCount }}间</span>
              </div>
            </div>
          </div>
        </div>
        <div class="rs-tbody">
          <div class="rs-tr" v-for="(item, index) in roomStatusList" :key="item.id">
            <div :class="`rs-td ${item.skip ? 'no-t-border' : ''}`">
              <div class="flex-a-j-center">
                {{ item.skip ? '' : item.roomTypeName }}
              </div>
            </div>
            <div class="rs-td">
              <el-popover
                placement="top-start"
                effect="dark"
                trigger="click"
                popper-class="cell-popper2"
              >
                <template #reference>
                  <div class="flex-a-j-center">
                    <span class="flex-a-j-center" style="cursor: pointer;">{{ item.roomName }}</span>
                    <span v-if="item.cleanStatus == 2" style="color: blue; border: 2px solid blue; border-radius: 4px; margin-left: 8px; width: 20px; height: 20px; display: flex; justify-content: center; align-items: center;">{{item.cleanStatus == 2 ? '脏' : ''}}</span>
                  </div>
                </template>
                <div class="oper-popover">
                  <ul class="oper-btn-group">
                    <li
                      :class="`oper-btn ${index > 0 ? 'top-divider' : ''}`"
                      style="width: 64px;"
                      @click="handleClickOperBtn({type: item.cleanStatus == 2 ? 'setEmpty' : 'setDirty', id: item.roomId})"
                    >
                      置“{{item.cleanStatus == 2 ? '净' : '脏'}}”
                    </li>
                  </ul>
                </div>
              </el-popover>
              <div class="check-more" @click="handleShowDetail(item)">查看详情</div>
            </div>
            <!-- 单元格并非通过计算渲染，而是表格渲染 -->
            <div :class="`rs-td ${order.skip > 0 ? 'no-l-border' : ''}`" v-for="order in item.orderList" :key="order.dateVal">
              <!-- 都渲染popover弹层会严重耗费资源，所以最多仅渲染一个鼠标悬浮单元格的popover、一个选中单元格的popover -->
              <el-popover
                v-if="isCurHoverCell(order, item)" popper-class="cell-popper"
                :offset="-30"
                :teleported="false"
                width="auto"
                effect="dark"
                trigger="click"
                placement="top-start">
                <div class="oper-popover">
                  <ul class="oper-btn-group">
                    <li
                      :class="`oper-btn ${index > 0 ? 'top-divider' : ''}`"
                      v-for="(item, index) in getOperBtnGroup(order)"
                      :key="item.type"
                      @click="handleClickOperBtn(item)">{{ item.label }}</li>
                  </ul>
                </div>
                <template #reference>
                  <div :class="`order-card font-12 ${getCellClass(order, item)} ${getCurCellClass(order, item)}`" @click="handleClickCell(order)" :style="{
                    backgroundColor: order.status == 'dirty' ? '#9D9D9D' : ''
                  }">
                    <!-- 订单hover弹窗 -->
                    <div class="order_detail" v-if="order.status !== 'empty'">
                      <p style="font-weight: bold; font-size: 14px;">{{ order.statusName }}</p>
                      <p>预订人：{{ order.bookerName }}</p>
                      <p>手机号：{{ order.bookerPhone }}</p>
                      <p>渠道来源：{{ order.orderSourceName }}</p>
                      <p>时间：{{ order.proposedCheckInTime?.split(' ')[0] }} - {{ order.proposedCheckOutTime?.split(' ')[0] }}</p>
                    </div>
                    <div class="sel-cell" v-if="(order.dateVal === curSelCell.dateVal && item.id === curSelCell.parentProps.roomId) && order.status === 'empty'">
                      <el-icon size="34"><circle-check-filled /></el-icon>
                    </div>
                    <template v-else>
                      <div :class="`c-top bg-${order.status} ${order.status === 'empty' ? 'top-border' : ''}`">
                        <template v-if="order.status != 'dirty'">
                          <span>{{ order.skip > 0 ? '' : order.statusName }}</span>
                          <span v-if="order.orderType === 2 && order.skip === 0" class="time-order">时</span>
                        </template>
                      </div>
                      <div :class="`c-body b-c-${order.status}`" :style="{
                        border: order.status == 'dirty' ? 'none' : ''
                      }">
                        <div v-if="getIsShowOrderDetail(order)" class="order-detail">
                          <span>{{ order.bookerName }}</span>
                          <span>{{ order.stayCount }}</span>
                          <span :class="`color-${order.status}`">{{ order.orderSourceName }}</span>
                        </div>
                        <div v-if="order.status === 'dirty'" class="room-dirty">
                          <!-- <img :src="iconRoomDirty"> -->
                          <img src="./sweep.png">
                        </div>
                      </div>
                    </template>
                  </div>
                </template>
              </el-popover>

              <!-- 为了节省资源，一般情况下只是一个没有弹层的单元格 -->
              <div v-else :class="`order-card font-12 ${getCellClass(order, item)} ${getCurCellClass(order, item)}`" @mouseover="handleHoverCell(order)" :style="{
                backgroundColor: order.status == 'dirty' ? '#9D9D9D' : ''
              }">
                <div class="sel-cell" v-if="(order.dateVal === curSelCell.dateVal && item.id === curSelCell.parentProps.roomId) && order.status === 'empty'">
                  <el-icon :size="34"><circle-check-filled /></el-icon>
                </div>
                <div v-else-if="order.status === 'empty'" style="display: flex; justify-content: center; align-items: center; height: 100%;">
                  <el-icon size="16px"><CirclePlus /></el-icon>
                </div>
                <template v-else>
                  <div :class="`c-top bg-${order.status} ${order.status === 'empty' ? 'top-border' : ''}`">
                    <template v-if="order.status != 'dirty'">
                      <span>{{ order.skip > 0 ? '' : order.statusName }}</span>
                      <span v-if="order.orderType === 2 && order.skip === 0" class="time-order">时</span>
                    </template>
                  </div>
                  <div :class="`c-body b-c-${order.status}`" :style="{
                    border: order.status == 'dirty' ? 'none' : ''
                  }">
                    <div v-if="getIsShowOrderDetail(order)" class="order-detail">
                      <span>{{ order.bookerName }}</span>
                      <span>{{ order.stayCount }}</span>
                      <span :class="`color-${order.status}`">{{ order.orderSourceName }}</span>
                    </div>
                    <div v-if="order.status === 'dirty'" class="room-dirty">
                      <!-- <img :src="iconRoomDirty"> -->
                      <img src="./sweep.png">
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <DrawerRoomType v-model="filterRoomTypeDrawer" :sel-list="selRoomTypeList" :type-list="dictList.roomType" @change="handleChangeRoomType" />
    <DrawerEditOrder v-model="addOrderDrawer" :default-data="curSelCell" :dict-list="dictList" @close="getStatusList" />
    <DrawerCleanTask v-model="cleanTaskDrawer" :info="curSelCell" @close="handleDrawerClose" />

    <!-- 复合弹框 -->
    <RModal :title="modalTitles[modalType]" v-model="fixModal" top="3vh" :closeOnClick="false" @change="fixModal = false" @close="closeFixModal" width="1000px">
      <template #content>
        <DetailView
          v-if="modalType == 'show'"
          hidden-number-bol
          :sel-options="dictList"
          :detail-data="orderDetail"
          :detail-modal="fixModal"
          @submitSuccess="handleModalSuccess"
          @handleRowEdit="handleRowEdit" />

        <EditView
          v-else-if="modalType == 'add' || modalType == 'edit' || modalType == 'reserveAgain'"
          :sel-options="dictList"
          :detail-type="modalType"
          :detail-data="orderDetail"
          :detail-modal="fixModal"
          @submitSuccess="handleModalSuccess"
          @closeModel="closeFixModal" />

        <ExtendView
          v-else-if="modalType == 'extend'"
          :sel-options="dictList"
          :detail-type="modalType"
          :detail-data="orderDetail"
          :detail-modal="fixModal"
          @submitSuccess="handleModalSuccess"
          @closeModel="closeFixModal" />

        <ChangeHouseView
          v-else-if="modalType == 'changeHouse'"
          :sel-options="dictList"
          :detail-type="modalType"
          :detail-data="orderDetail"
          :detail-modal="fixModal"
          @submitSuccess="handleModalSuccess"
          @closeModel="closeFixModal" />

        <CheckoutView
          v-else-if="modalType == 'checkout'"
          :sel-options="dictList"
          :detail-type="modalType"
          :detail-data="orderDetail"
          :detail-modal="fixModal"
          @submitSuccess="handleModalSuccess"
          @closeModel="closeFixModal" />
      </template>
    </RModal>
    
    <RModal
      v-model="earlyCheckinModal"
      width="800px"
      title="办理提前入住"
      :closeOnClick="false"
      @change="earlyCheckinModal = false"
      @close="earlyCheckinModal = false">
      <template #content>
        <EarlyCheckinView :show="earlyCheckinModal" :form-data="orderDetail" @cancel="earlyCheckinModal = false" @success="handleEarlyCheckSuccess" />
      </template>
    </RModal>
    <RModal :title="`详情`" v-model="detailModal" top="3vh" :closeOnClick="false" @change="detailModal = false" @close="closeModel">
      <template #content>
        <RoomDetailView :detailModal="detailModal" :detailData="detailData"></RoomDetailView>
      </template>
    </RModal>
    <RModal 
      :title="`订单列表`" 
      v-model="orderListModal"
      top="3vh" 
      :closeOnClick="false" 
      @change="orderListModal = false"
      @close="orderListModal = false">
      <template #content>
        <orderList :list="orderList" @toDetail="toDetail"></orderList>
        <div style="text-align: center;">
          <el-button type="primary" @click="newOrder">新增订单</el-button>
        </div>
      </template>
    </RModal>
  </div>
</template>

<script>
import mixin from './index'

import iconCleaning from '@/assets/img/icon/icon-roomclean-doing.png'
import iconNeedClean from '@/assets/img/icon/icon-roomclean-before.png'
import iconRoomDirty from '@/assets/img/icon/icon-room-dirty.png'

import RModal from '@/components/common/RModal'
import DrawerRoomType from '../drawerForm/drawerRoomType.vue'
import DrawerEditOrder from '../drawerForm/drawerEditOrder.vue'
import DrawerCleanTask from '../drawerForm/drawerCleanTask.vue'

import RoomDetailView from '@/views/baseInfo/room/detailView.vue'
import EditView from '@/views/baseInfo/order/editView.vue'
import DetailView from '@/views/baseInfo/order/detailView.vue'
import ExtendView from '@/views/baseInfo/order/extendView.vue'
import CheckoutView from '@/views/baseInfo/order/checkOutView.vue'
import ChangeHouseView from '@/views/baseInfo/order/changeHouseView.vue'
import EarlyCheckinView from '@/views/baseInfo/order/earlyCheckinView.vue'

import orderList from "@/views/baseInfo/order/orderList.vue";
import moment from 'moment'

export default {
  mixins: [ mixin ],
  components: {
    RModal,
    DrawerRoomType,
    DrawerEditOrder,
    DrawerCleanTask,
    EditView,
    DetailView,
    ExtendView,
    CheckoutView,
    ChangeHouseView,
    EarlyCheckinView,
    RoomDetailView,
    orderList,
  },
  data() {
    return {
      orderListModal: false,
      orderList: [],
      detailModal: false,
      detailData: {},
      iconRoomDirty,
      storeId: '',

      curSelCell: {}, // 当前选中单元格
      curHoverCell: {}, // 当前鼠标悬浮单元格
      selDate: '2022-04-14', // 当前选择日期

      addOrderDrawer: false, // 新增订单抽屉
      cleanTaskDrawer: false, // 保洁任务抽屉
      selRoomTypeList: [], // 房型选中列表
      filterRoomTypeDrawer: false, // 房型筛选抽屉

      // 保洁状态列表
      cleanStatusList: [
        { id: '1', label: '保洁打扫中', imgUrl: iconCleaning },
        { id: '2', label: '脏房需打扫', imgUrl: iconNeedClean },
      ],
      // 日期列表
      dateList: [],
      // 房态列表
      roomStatusList: [],

      fixModal: false, // 复合弹框
      modalType: '', // 复合弹框类型
      orderDetail: {}, // 订单详情
      // 复合弹框标题
      modalTitles: {
        add: '新增',
        edit: '变更',
        show: '详情',
        copy: '复制',
        bind: '绑定',
        check: '审核',
        extend: '续住',
        checkout: '办理退房',
        changeHouse: '换房',
        reserveAgain: '再次预订'
      },

      earlyCheckinModal: false, // 提前入住弹框
    }
  },
  methods: {
    toDetail(id){
      this.curSelCell.id = id;
      this.getOrderDetailInfo(() => {
        this.modalType = 'show'
        this.fixModal = true
      })
    },
    newOrder(){
      if (this.curSelCell.parentProps.reviewStatus != 2) {
        this.$message.error('该房源未审核通过，无法录入订单')
      } else {
        this.orderListModal = false;
        this.addOrderDrawer = true
      }
    },
    //获取详情信息
    async getDetailInfo(id){
      let url = 'SAAS.ROOM_DETAIL'
      let params = {id:id}
      let detailInfo  = await this.fetchData({
        url,
        method: 'get',
        params,
        flag:true
      })
      return detailInfo
    },
    handleShowDetail(row) {
      console.log(row);
      this.getDetailInfo(row.id).then((res)=>{
        this.detailData = {...res.data} || {}
        this.$nextTick(()=>{
          this.detailModal = true
        })
      }).catch((err)=>{
        console.log(err,'err======')
      })
    },
    closeModel(){
      this.detailModal = false;
    },
    // 处理操作按钮点击
    handleClickOperBtn(btn) {
      switch(btn.type) {
        case 'orderDetail':
          const day = moment(this.curSelCell.proposedCheckInTime).format('YYYY-MM-DD')
          this.fetchData({
            url: 'SAAS.ORDER_QUERY_LIST',
            method: 'get',
            params: {
              pageNumber: 1,
              pageSize: 100,
              storeId: this.curSelCell.storeId,
              roomId: this.curSelCell.roomId,
              proposedCheckInStartTime: day +' 00:00:00',
              proposedCheckInEndTime: day +' 23:59:59',
            },
            flag:true
          }).then((res) => {
            this.orderListModal = true;
            this.orderList = res.data.data;
          })
          break
        case 'addOrder':
          if (this.curSelCell.parentProps.reviewStatus != 2) {
            this.$message.error('该房源未审核通过，无法录入订单')
          } else {
            this.addOrderDrawer = true
          }
          break
        case 'reserveAgain':
          this.getOrderDetailInfo(() => {
            this.modalType = 'reserveAgain'
            this.fixModal = true
          })
          break
        case 'setDirty':
          this.changeRoomInfo({ cleanStatus: 2, id: btn.id })
          break
        case 'setEmpty':
          this.changeRoomInfo({ cleanStatus: 1, id: btn.id })
          break
        case 'changeRoom':
          this.getOrderDetailInfo(() => {
            this.modalType = 'changeHouse'
            this.fixModal = true
          })
          break
        case 'earlyStay':
          this.getOrderDetailInfo(this.openEarlyCheckinModal)
          break
        case 'cancelOrder':
          this.handleRowEdit({ id: this.curSelCell.id }, 'cancel')
          // this.getOrderDetailInfo(res => {
            
          // })
          break
        case 'checkout':
          this.getOrderDetailInfo(() => {
            this.modalType = 'checkout'
            this.fixModal = true
          })
          break
        case 'continueStay':
          this.getOrderDetailInfo(() => {
            this.modalType = 'extend'
            this.fixModal = true
          })
          break
        case 'clean':
          this.cleanTaskDrawer = true
          break
      }
    },
    // 获取订单详情信息
    getOrderDetailInfo(cb) {
      let url = 'SAAS.ORDER_QUERY_DETAIL'
      let params = { id: this.curSelCell.id }
      this.fetchData({ url, method: 'get', params, flag: true }).then(res => {
        if (res.code != 200) {
          return this.$message.error(res.msg || '读取订单失败！')
        }
        this.orderDetail = res.data || {}

        cb && cb(res)
      })
    },
    // 处理单元格悬停，加上popover
    handleHoverCell(order) {
      this.curHoverCell = { ...order, storeId: this.storeId }
    },
    // 处理单元格点击，并加上popover
    handleClickCell(order) {
      this.curSelCell = { ...order, storeId: this.storeId }
    },
    openFixModal() {
      this.fixModal = true
    },
    // 关闭复合弹框
    closeFixModal() {
      this.fixModal = false
    },
    openEarlyCheckinModal() {
      this.earlyCheckinModal = true
    },
    // 关闭提前入住弹框
    closeEarlyCheckinModal() {
      this.earlyCheckinModal = false
    },
    // 处理复合弹框提交成功
    handleModalSuccess() {
      this.closeFixModal()
      this.getStatusList()
    },
    // 处理提前入住提交成功
    handleEarlyCheckSuccess() {
      this.closeEarlyCheckinModal()
      this.getStatusList()
    },
    // 处理房型筛选
    handleFilterRoomType() {
      this.filterRoomTypeDrawer = true
    },
    // 处理房型选中变更
    handleChangeRoomType(list) {
      this.selRoomTypeList = list
      this.getStatusList()
    },
    // 处理抽屉关闭
    handleDrawerClose() {
      if (this.curSelCell.dateVal === this.todayValue) {
        this.getStatusList()
      }
    }
  }
}

</script>

<style lang="less" scoped>
@import url('./index.less');
.check-more{
  border-radius: 1000px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px 12px;
  background: rgba(252, 191, 12, 0.1);
  box-sizing: border-box;
  border: 1px solid #FCBF0C;
  margin: 0 12px;
  color: #FCBF0C;
  cursor: pointer;
}
</style>

<style lang="less">
.z-i-10000 {
  z-index: 10000 !important;
}
.cell-popper {
  padding: 0px !important;
  min-width: 80px !important;
  background-color: rgb(70, 76, 91);
  z-index: 99 !important;
}
.cell-popper2{
  padding: 0px !important;
  background-color: rgb(70, 76, 91);
  z-index: 99 !important;
  max-width: 64px !important;
  min-width: 64px !important;
}
.color-black {
  color: black;
}
.r-drawer {
  .el-drawer__body {
    border-top: 1px solid #dfdfdf;
  }
}
</style>